<template>
    <div class="hotel">
        <!-- Grid -->
        <div class="card card-featured-hotel" v-if="vista=='G'">
        <!-- ficha hotel -->
            <img :src="imgUrl" :alt="item.name" class="card-img-top"/>
            <div class="card-body">
                <div class="days-price d-flex justify-content-between">
                    <div class="card-hotel-days">
                        <img :src="require('@/assets/css/img/calendar-icon.svg')" />
                        {{ item.dias }} días
                    </div>
                    <div class="sec-price d-flex flex-column align-items-end">
                        <div class="price">
                            <span class="price--desde pr-1">desde</span>
                            {{ item.precio }}
                            <span class="price--symbol">€</span>
                        </div>
                        <div class="card-price-small-text">por persona</div>
                    </div>
                </div>
                <h5 class="hotel-title pt-3 mb-0">{{ item.hotel }}</h5>
                <!-- <div class="hotel-stars">
                    <img src="img/hotel-star-icon.svg" alt="" />
                    <img src="img/hotel-star-icon.svg" alt="" />
                    <img src="img/hotel-star-icon.svg" alt="" />
                </div> -->
                <div class="card-hotel-location">
                    <!-- <img :src="require('@/assets/css/img/map-marker-icon.svg')" />                         -->
                    <b-icon-geo-alt></b-icon-geo-alt>
                    {{ item.pobla }}
                </div>
                <div class="card-hotel-include mt-4">{{ item.info }}</div>

                <div class="text-center">
                    <b-btn variant="outline-secondary" class="mt-2 mr-2" pill size="sm"
                        @click="hotel_info(item)"
                        ><i class="fas fa-info-circle mr-1"></i>Info
                    </b-btn>
                    <b-btn variant="outline-secondary" class="mt-2" pill size="sm"
                        @click="hotel_precios(item)"
                        ><i class="fas fa-search mr-1"></i>Precios
                    </b-btn>
                </div>
            </div>
        </div>

        <!-- Lista -->
        <div class="d-flex" v-else>
            <div class="card-hotel-info d-flex col-3">
                <div class="card-hotel-img ">
                    <!-- <img src="img/hotel-prince-park.jpg" alt="Hotel Prince Park" /> -->
                    <img :src="imgUrl" :alt="item.hotel"/>
                </div>
            </div>
            <div class="card-body col-9 d-flex flex-wrap">
                <div class="col-xs-12 col-md-8 mb-2">
                    <h5 class="hotel-title mb-0">{{ item.hotel }}</h5>
                    <!-- <div class="hotel-stars">
                        <img src="img/hotel-star-icon.svg" alt="" />
                        <img src="img/hotel-star-icon.svg" alt="" />
                        <img src="img/hotel-star-icon.svg" alt="" />
                    </div>                 -->
                    <div class="card-hotel-location">
                        <b-icon-geo-alt></b-icon-geo-alt>
                        {{ item.pobla }}
                    </div>
                    <div class="card-hotel-include mt-3">
                        <p class="font-weight-bold">El precio incluye</p>{{ item.info }}
                    </div>
                    <div class="pt-3">
                        <b-btn variant="outline-dark" class="mx-1" size="sm"
                            @click="hotel_info(item)"
                            ><i class="fas fa-info-circle mr-2"></i>Información Hotel
                        </b-btn>
                    </div>
                </div>
                <div class="price-days-booking col-xs-12 col-md-4 d-flex flex-column justify-content-between">
                    <div class="sec-price d-flex flex-column align-items-end">
                        <div class="price">
                            <span class="price--desde pr-1">desde</span>
                            {{ item.precio }}
                            <span class="price--symbol">€</span>
                        </div>
                        <div class="card-price-small-text">por persona</div>
                    </div>
                    <div class="card-hotel-days text-right mb-2">
                        <!-- <img src="/img/calendar-icon.svg" alt=""/> -->
                        <img :src="require('@/assets/css/img/calendar-icon.svg')" />
                        {{ item.dias }} días
                    </div>
                    <div class="text-right">
                        <b-btn variant="outline-dark" class="mx-1" size="sm"
                            @click="hotel_precios(item)"
                            ><i class="fas fa-search mr-1"></i>Precios
                        </b-btn>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

//import { mapActions } from 'vuex';

export default {
    name: 'hotel',
    props: {
        item: Object,
        //vista: Number,
    },
    data() {
        return {

        }
    },

    mounted() {

    },

    computed: {
        vista() {
            return this.$parent.vista;
        },

        imgUrl() {
            return this.$store.getters.hotel_imagen("||" + this.item.hot);
        },
    },
    methods: {
        //...mapActions(['imagenUrl']),

        hotel_info(item) {
            console.log("*hotel.hotel_info",item);
            //alert('Informacion Hotel');
            this.$parent.hotel_info(item);
        },
        hotel_precios(item) {
            console.log("*hotel.preciosyturnos",item);
            this.$parent.hotel_precios(item);
        },

    },

}
</script>